import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/images/booster.png")